<template lang="pug">
div(v-if="processo")
  .analise-automatizada-header
    span Análise do Processo {{ processo.numeroProcesso }}
    app-opcoes-header-analise.right(
      :idProcesso="processo.id",
      :protocolo="processo.numeroProtocolo"
      :statusProcesso="processo.status"
      :numeroProcesso="processo.numeroProcesso",
      :btnSolicitarInformacao="false"
      :btnRetificacao="false"
      :tipoProcesso="processo.tipo.codigo"
      :btnNotificarInteressado="false"
    )
  el-steps(:active='active', finish-status='success', simple)
    el-step(title='Informar dados')
    el-step(title='Confirmar dados')

  validation-observer(ref="observer" tag="div")
    .step(v-if="active === 2")
      app-pdf-viewer(v-if="bytes", :bytes="bytes" :customStyle="{'height': '700px'}")
      app-radios-tramitacao(
        :radios="radios",
        :isDecisao="isDecisao",
        @changeRadio="changeRadio",
      )

    .step(v-else)
        el-row.margin-medium-top(:gutter="20")
          el-col(:span="6")
            app-label(
              label="Processo:",
              :required="true"
            )
            el-input.input(
              :value='dadosAnalise.numeroProcesso',
              :disabled="true"
            )
          el-col(:span="6")
            app-label(
              label="Tipo de Processo:",
              :required="true"
            )
            el-input.input(
              :value='dadosAnalise.tipoProcesso.nome',
              :disabled="true"
            )

          el-col(:span="12")
            app-label(
              label="Interessado:",
              :required="true"
            )
            el-input.input(
              :value='dadosAnalise.nomeRazaoSocialInteressado',
              :disabled="true"
            )
        el-row.margin-medium-top(:gutter="20")
          el-col(:span="12", v-if="!isReurb")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(
                label="Denominação:",
              )
              el-input.input(
                v-model="dadosAnalise.denominacaoImovel",
                name='denominacao',
                :class="{'erro' : errors.length}",
                :disabled="!!processo.dadosCadastro.dados.cadastro.imovel.nome || !!processo.dadosCadastro.dados.cadastro.imovel.denominacao"
              )
              span.help.erro {{ errors[0] }}

          el-col(:span="12")
            app-label(
              label="Município:",
              :required="true"
            )
            el-input.input(
              :value='municipiosFormatados',
              :disabled="true"
            )
          el-col(:span="6", v-if="isReurb")
            app-label(
              label="Área do Georreferenciamento (ha):",
              :required="true"
            )
            el-input.input(
              :value='formatDouble(dadosAnalise.areaImovel, 4)',
              :disabled="true"
            )

          el-col(:span="6", v-if="isReurb")
            app-label(
              label="Perímetro (m):",
              :required="true"
            )
            el-input.input(
              :value='formatDouble(dadosAnalise.perimetroImovel, 2)',
              :disabled="true"
            )

        el-row.margin-medium-top(:gutter="20", v-if="!isReurb")
          el-col(:span="12")
            app-label(
              label="Recibo do CAR:",
              :required="false"
            )
            validation-provider(:rules="dadosAnalise.numeroReciboCar ? 'car' : ''", v-slot="{ errors }")
              el-input.input(
                :disabled="!!processo.dadosCadastro.dados.cadastro.imovel.numeroReciboCar"
                v-model="dadosAnalise.numeroReciboCar",
                name="Número do recibo do CAR",
                v-mask="customMask",
                :class="{'erro' : errors.length}"
              )
              span.help.erro {{ errors[0] }}
          el-col(:span="6")
            app-label(
              label="Área do Georreferenciamento (ha):",
              :required="true"
            )
            el-input.input(
              :value='formatDouble(dadosAnalise.areaImovel, 4)',
              :disabled="true"
            )

          el-col(:span="6")
            app-label(
              label="Perímetro (m):",
              :required="true"
            )
            el-input.input(
              :value='formatDouble(dadosAnalise.perimetroImovel, 2)',
              :disabled="true"
            )

        //- Tabelas
        div.tabelas(v-for="tabela in calculosAnalise.tabelas" :key="tabela.tipo")
          app-divider(:label="tabela.nome")
          el-table(
            :data="tabela.conteudo",
            max-height="500"
          )
            div(slot='empty')
              span(v-if="tabela.tipo === 'metadadosDaBaseVetorialOficialAtualizada' || tabela.tipo === 'analiseDaBaseVetorialOficial'") A geometria do imóvel não sobrepõe com nenhuma camada da base de dados oficiais.
              span(v-else) A geometria do imóvel não sobrepõe com nenhuma camada da base da BDF.
            el-table-column(
              :label="tabela.labelColunaPrincipal"
              prop="camada"
            )

            el-table-column(
              v-for="coluna in tabela.colunasSobreposicoes"
              :label='coluna.label'
              :key="coluna.propName"
            )
              template(slot-scope="scope")
                div(v-if="tabela.tipo === 'analiseDaBaseDigitalFundiaria' && coluna.propName === 'nome'")
                  span {{ scope.row.ano + '/' + scope.row.processo + ' - ' + scope.row.interessado }}
                div(v-else-if="coluna.propName === 'informacoes'")
                  span(v-if="scope.row.informacoes.length == 0") -
                  template(v-for="info in scope.row.informacoes")
                    .info-sobreposicao(v-if="tabela.tipo === 'metadadosDaBaseVetorialOficialAtualizada'")
                      span {{  info.valor  }}
                    .info-sobreposicao(v-else)
                      span {{ info.nome + ' (' + info.valor + ')' }}

                span(v-else-if="coluna.propName === 'porcentagem'") {{ formatDouble(scope.row[coluna.propName], 2) || '-' }}
                span(v-else-if="coluna.propName === 'area'") {{ formatDouble(scope.row[coluna.propName], 4) || '-' }}
                span(v-else) {{ scope.row[coluna.propName] || '-' }}

        div.campo
          app-label(label="Observações", :required="false")
          app-editor-texto.input(
            v-if="!isLoading"
            @onTextChange="onChangeObservacoes",
            v-model="dadosAnalise.observacoes"
            ref="textoObservacoes"
          )

        validation-provider.campo(rules="required", v-slot="{ errors }" tag="div")
          app-label(label="Conclusão")
          app-editor-texto.input(
            v-if="!isLoading"
            @onTextChange="onChangeConlusao",
            v-model="dadosAnalise.conclusao",
            :class="{'erro' : errors.length}"
            ref="textoConclusao"
          )
          span.help.erro {{ errors[0] }}

        slot(name="anexoMapas")

  app-buttons-cadastro(
    :isUltimoPasso="isLastStep",
    :isPrimeiroPasso="!isLastStep",
    :showButtonSalvar="!isLastStep",
    :showButtonCancelar="!isLastStep"
    :showButtonDownload="isLastStep"
    :showButtonAnaliseManual="!isLastStep"
    :showButtonProximo="!isLastStep"
    labelButtonAnaliseManual="Análise manual"
    @proximo="proximo"
    @voltar="$emit('setActive', 1)"
    @finalizar="finalizar",
    @cancelar="cancelar"
    @salvar="salvar"
    @changeAnalise="changeAnalise"
    @download="downloadPdf"
  )
</template>

<script>

import AppOpcoesHeaderAnalise from './components/modal/AppOpcoesHeaderAnalise'
import AppLabel from '@/components/AppLabel'
import AppDivider from '@/components/AppDivider'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppPdfViewer from '@/components/AppPDFViewer'
import axios from '@/utils/api'
import utils from '@/utils/utils'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
const {
  analiseAutomatizada
} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  mixins: [
    AppNotificacao
  ],

  components: {
    AppOpcoesHeaderAnalise,
    AppLabel,
    AppDivider,
    AppEditorTexto,
    AppButtonsCadastro,
    AppPdfViewer,
    AppRadiosTramitacao
  },

  data () {
    return {
      isLoading: false,
      calculosAnalise: {
        dados: []
      },
      dadosAnalise: {
        tipoProcesso: {
          nome: ''
        },
        municipios: [],
        observacoes: '',
        conclusao: ''
      },
      processo: null,
      bytes: null,
      customMask: {
        mask: 'AA-NNNNNNN-FFFF.FFFF.FFFF.FFFF.FFFF.FFFF.FFFF.FFFF',
        tokens: {
          A: {
            pattern: /[a-zA-Z]/,
            transform: v => v.toLocaleUpperCase()
          },
          N: {
            pattern: /\d/
          },
          F: {
            pattern: /[0-9a-fA-F]/,
            transform: v => v.toLocaleUpperCase()
          }
        }
      }
    }
  },

  props: {
    protocoloProcesso: {
      type: String,
      required: true
    },
    analiseSalva: {
      type: Object
    },
    idDespacho: {
      type: Number
    },
    radios: {
      type: Array,
      required: true
    },
    isDecisao: {
      type: Boolean,
      required: true
    },
    active: {
      type: Number
    },
    tipoProcesso: {
      type: String,
      required: true
    }
  },

  async created () {
    this.isLoading = true
    this.processo = await this.getProcessoWithCadastro(this.protocoloProcesso)
    this.calculosAnalise = await JSON.parse(await this.getDadosAnaliseAutomatizada(this.processo.numeroProtocolo))

    this.dadosAnalise = {
      numeroProcesso: this.processo.numeroProcesso,
      tipoProcesso: this.processo.tipo,
      nomeRazaoSocialInteressado: this.processo.nomeRazaoSocialInteressado,

      areaImovel: this.calculosAnalise.dados.area,
      perimetroImovel: this.calculosAnalise.dados.perimetro,
      municipios: this.calculosAnalise.dados.municipios,

      id: this.analiseSalva ? this.analiseSalva.id : null,
      observacoes: this.analiseSalva ? this.analiseSalva.observacoes : '',
      conclusao: this.analiseSalva && this.analiseSalva?.conclusao ? this.analiseSalva.conclusao : analiseAutomatizada[this.tipoProcesso].conclusao,
      jsonAnalise: JSON.stringify(this.calculosAnalise)
    }

    if (!this.isReurb) {
      this.dadosAnalise = {
        ...this.dadosAnalise,
        denominacaoImovel: this.analiseSalva ? this.analiseSalva.denominacaoImovel : (this.processo.dadosCadastro.dados.cadastro.imovel.nome || this.processo.dadosCadastro.dados.cadastro.imovel.denominacao),
        numeroReciboCar: (this.analiseSalva && this.analiseSalva.numeroReciboCar) ? this.analiseSalva.numeroReciboCar : this.processo.dadosCadastro.dados.cadastro.imovel.numeroReciboCar
      }
    }

    if (this.active === 2) {
      await this.getPdfView()
    }

    this.isLoading = false
  },

  computed: {
    isLastStep () {
      return this.active === 2
    },

    isReurb () {
      return this.tipoProcesso === 'REGULARIZACAO_URBANA'
    },

    municipiosFormatados: {
      get () {
        return this.dadosAnalise.municipios.map(item => item.nome).join(', ')
      },
      set () {

      }
    }
  },

  methods: {
    ...mapActions({
      getDadosAnaliseAutomatizada: 'processos/getDadosAnaliseAutomatizada',
      getProcessoWithCadastro: 'processos/getProcessoByProtocolo'
    }),

    onChangeObservacoes (text) {
      this.dadosAnalise.observacoes = text.replace(/<br>/g, '<br/>')
    },

    onChangeConlusao (text) {
      this.dadosAnalise.conclusao = text.replace(/<br>/g, '<br/>')
    },

    salvar () {
      this.$emit('salvar', { dadosAnalise: this.dadosAnalise, done: () => {} })
    },

    cancelar () {
      this.$emit('cancelar')
    },

    async proximo () {
      const valido = await this.$refs.observer.validate()

      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.VALIDATION_FAIL)
        return
      }

      this.$emit('setActive', 2)
      this.$emit('salvar', { dadosAnalise: this.dadosAnalise })
    },

    async finalizar () {
      const valido = await this.$refs.observer.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.ERROS_ANALISE)
        return
      }
      this.$emit('finalizar', this.dadosAnalise)
    },

    changeAnalise () {
      this.confirmBox('Tem certeza que deseja alterar o tipo de análise? Os dados preenchidos serão perdidos.', this.$messages.TITULO_WARNING,
        () => {
          this.dadosAnalise.observacoes = ''
          this.dadosAnalise.conclusao = ''
          this.$emit('changeAnalise', true)
        },
        () => { })
    },

    changeRadio (value) {
      this.$emit('changeRadio', value)
    },

    async getPdfView () {
      this.bytes = await axios({
        method: 'GET',
        url: `analiseAutomatizada/laudoPdfView/${this.idDespacho}`,
        responseType: 'arraybuffer'
      })
    },

    async downloadPdf () {
      await axios({
        method: 'GET',
        url: 'analiseAutomatizada/laudoPdfDownload/' + this.idDespacho,
        responseType: 'blob'
      })
    },

    formatDouble (val, precision) {
      return utils.format(val, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision })
    }
  }

}
</script>

<style lang="scss" scoped>

.analise-automatizada-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px;
}

.campo {
  margin-top: 2%;
}

.info-sobreposicao {
  display: flex;
}

.row-sobreposicao {
  padding: 5px 0;
  min-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/AnaliseAutomatizada.vue